<template>
  <div>
    <div class="header-radiobtn-wrapper text-center">
      <!-- Client -->
      <label
        class="container-radio ver-bar"
        @click.prevent="selected = 'client'"
      >
        <span
          class="checkmark"
          :class="{ checked: selected === 'client' }"
        ></span
        >Client
      </label>

      <!-- Person -->
      <label class="container-radio" @click.prevent="selected = 'person'">
        <span
          class="checkmark"
          :class="{ checked: selected === 'person' }"
        ></span
        >Person
      </label>

      <!-- Event -->
      <label class="container-radio" @click.prevent="selected = 'event'">
        <span
          class="checkmark"
          :class="{ checked: selected === 'event' }"
        ></span
        >Event
      </label>

      <!-- Group -->
      <label class="container-radio" @click.prevent="selected = 'group'">
        <span
          class="checkmark"
          :class="{ checked: selected === 'group' }"
        ></span
        >Group
      </label>
    </div>
    <!-- Inner drop downs -->
    <transition name="drop" appear mode="out-in">
      <add-person-toggle
        v-if="selected === 'person'"
        :hide-drop-down="hideDropDown"
      />
      <add-event-toggle
        v-if="selected === 'event'"
        :hide-drop-down="hideDropDown"
      />
      <add-group-toggle
        v-if="selected === 'group'"
        :hide-drop-down="hideDropDown"
      />
    </transition>
  </div>
</template>

<script>
import AddPersonToggle from "../Appointment/AddAppointment/AddToggle/AddPersonToggle";
import AddEventToggle from "../Appointment/AddAppointment/AddToggle/AddEventToggle";
import AddGroupToggle from "../Appointment/AddAppointment/AddToggle/AddGroupToggle";

export default {
  props: {
    hideAdd: Function
  },
  data() {
    return {
      selected: false
    };
  },
  components: {
    AddPersonToggle,
    AddEventToggle,
    AddGroupToggle
  },
  methods: {
    hideDropDown() {
      this.hideAdd();
    }
  },
  watch: {
    selected(value) {
      if (value === "client") {
        this.$router.push("/add_client");
      }
    }
  }
};
</script>

<style scoped>
.header-radiobtn-wrapper {
  display: flex;
  padding-bottom: 10px;
  max-width: 600px;
  margin: 0 auto;
  clear: both;
  padding-top: 5px;
  justify-content: center;
}

.ver-bar {
  margin-right: 10px;
}
.container-radio.ver-bar {
  padding-right: 5px;
}
</style>
